import React from "react";
import { Search, Users, ClipboardCheck, Handshake, ArrowRight } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    title: "1. Discovery",
    desc: "We sit down with you to understand the role, the team, the culture and the urgency — so we hire for fit, not just fill seats.",
  },
  {
    icon: Users,
    title: "2. Sourcing",
    desc: "We tap our active database, network referrals and targeted outreach to build a shortlist of relevant, available, vetted candidates.",
  },
  {
    icon: ClipboardCheck,
    title: "3. Screening",
    desc: "Each candidate goes through structured screening — skills, motivation, communication and background — before they reach you.",
  },
  {
    icon: Handshake,
    title: "4. Placement",
    desc: "We coordinate interviews, support negotiations and stay involved through onboarding to make sure the hire actually sticks.",
  },
];

export default function OurProcess() {
  return (
    <section
      id="our-process"
      className="py-20 md:py-28 bg-brand-surfaceAlt"
      data-testid="our-process-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
            Our Process
          </span>
          <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            A clear, four-step hiring workflow.
          </h2>
          <p className="mt-4 text-brand-muted leading-relaxed">
            No black boxes, no jargon. Here’s exactly how we work with you from first
            conversation to a confirmed hire.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {STEPS.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              className="relative rounded-3xl bg-white border border-brand-border p-6 lg:p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
              data-testid={`process-step-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-brand-soft grid place-items-center text-brand-primary">
                <Icon size={22} />
              </div>
              <h3 className="mt-6 font-heading text-xl font-medium">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-brand-muted">{desc}</p>

              {i < STEPS.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 rounded-full bg-white border border-brand-border items-center justify-center text-brand-primary shadow-sm">
                  <ArrowRight size={12} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
